import { Building2, Check } from "lucide-react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { useSwitchOrganization } from "@/lib/use-switch-organization";
import { recarregarNaOrganizacao } from "@/lib/recarregar-na-organizacao";
import { ROLE_LABEL } from "@/components/layout/OrganizationSwitcherPartes";
import { CreatePersonalOrgSection } from "@/components/profile/CreatePersonalOrgSection";

const TIPO: Record<string, string> = { DENTAL_OFFICE: "Clínica", DENTAL_LAB: "Laboratório", RADIOLOGY_CENTER: "Radiologia" };

/** Onde a pessoa trabalha: cada organização com o papel dela e o atalho pra entrar. */
export function OrganizacoesSecao() {
  const user = trpc.me.current.useQuery().data;
  const lista = trpc.organization.listMine.useQuery();
  const { switchTo, isSwitching } = useSwitchOrganization();
  if (!user) return null;
  const temPessoal = (lista.data ?? []).some((m) => m.organization.isPersonal);
  const ativa = user.activeOrganization?.id;

  const entrar = (org: NonNullable<typeof lista.data>[number]["organization"]) =>
    switchTo(org.id)
      .then(() => recarregarNaOrganizacao(org, "/inicio"))
      .catch((err) => toast.error(err.message || "Não foi possível trocar de organização."));

  return (
    <div className="space-y-5 px-6 py-5">
      <ul className="divide-y divide-zinc-100 rounded-lg border border-zinc-200 dark:divide-border dark:border-border">
        {(lista.data ?? []).map(({ organization: o, role }) => (
          <li key={o.id} className="flex items-center gap-3 px-3 py-2.5">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-700 dark:bg-primary/15 dark:text-primary">
              <Building2 className="h-4 w-4" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium text-zinc-900 dark:text-foreground">{o.name}</span>
              <span className="block truncate text-xs text-zinc-500 dark:text-muted-foreground">
                {o.isPersonal ? "Pessoal" : [o.types.map((t) => TIPO[t] ?? t).join(" e "), ROLE_LABEL[role] ?? role].filter(Boolean).join(" · ")}
              </span>
            </span>
            {o.id === ativa ? (
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-600">
                <Check className="h-3.5 w-3.5" />
                Você está aqui
              </span>
            ) : (
              <button
                type="button"
                disabled={isSwitching}
                onClick={() => entrar(o)}
                className="h-8 shrink-0 rounded-md border border-zinc-200 bg-white px-3 text-xs font-medium text-brand-700 hover:bg-zinc-50 disabled:opacity-50 dark:border-border dark:bg-card dark:text-primary"
              >
                Entrar
              </button>
            )}
          </li>
        ))}
      </ul>
      {!lista.isLoading && !temPessoal && <CreatePersonalOrgSection initialName={user.name ?? ""} initialPhone={user.phone ?? ""} />}
    </div>
  );
}
